import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

export type viewerType = 'google' | 'office' | 'mammoth' | 'pdf';
@Component({
  selector: 'doc-viewer-angular',
  templateUrl: 'document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})
export class DocViewerComponent implements OnChanges {

  type: 'img' | 'object' | 'iframe' | 'none' = 'none'
  @Input() fileName?: any | SafeResourceUrl;
  @Input() urlTypeFile?: string;
  @Input() blankslateMessage?: any;
  @Input() url: any;
  @Input() loading?: boolean;
  fileType = '';
  zoomValue = 100;
  safeImageUrl: SafeUrl | null = null;

  TYPES: any = {
    'pdf': () => { this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(this.url); this.type = 'object' },
    'docx': () => { this.type = 'none' },
    'doc': () => { this.type = 'none' },
    'xlsx': () => { this.type = 'none' },
    'ppt': () => { this.type = 'none' },
    'pptx': () => { this.type = 'none' },
    'zip': () => { this.type = 'none' },
  }

  constructor(private domSanitizer: DomSanitizer) { }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const nextUrl = typeof this.url === 'string' ? this.url : this.url?.toString?.() ?? '';
    const currentType = this.resolveFileType(this.urlTypeFile ?? nextUrl);
    this.fileType = currentType;

    if (changes?.url && changes.url.currentValue !== changes.url.previousValue) {
      this.safeImageUrl = typeof this.url === 'string' && this.url.startsWith('blob:')
        ? this.domSanitizer.bypassSecurityTrustUrl(this.url)
        : null;
      if (nextUrl && typeof this.url === 'string') {
        this.handleViewerType();
      }
      return;
    }

    if (changes?.loading && changes.loading.currentValue !== changes.loading.previousValue) {
      if (nextUrl && typeof this.url === 'string') {
        this.handleViewerType();
      }
    }
  }

  private resolveFileType(value?: string): string {
    if (!value) {
      return '';
    }

    const normalizedValue = value.trim().split('?')[0].split('#')[0];
    if (normalizedValue.toLowerCase() === 'pdf') {
      return 'pdf';
    }

    const fileName = normalizedValue.split('/').pop() ?? normalizedValue;
    const extension = fileName.includes('.') ? fileName.split('.').pop()?.toLowerCase() : '';

    return extension || '';
  }

  private handleViewerType(): void {
    const urlValue = this.url;
    const normalizedUrl = urlValue.toLowerCase();

    if (normalizedUrl.includes('drive.google.com') || normalizedUrl.includes('docs.google.com')) {
      this.type = 'iframe';
      this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(urlValue);
      return;
    }

    if (this.fileType === 'pdf') {
      this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.addPdfViewerOptions(urlValue)
      );
      this.type = 'object';
      return;
    }

    this.TYPES[this.fileType] ? this.TYPES[this.fileType]() : this.type = 'img';
  }

  private addPdfViewerOptions(url: string): string {
    const separator = url.includes('#') ? '&' : '#';
    return `${url}${separator}navpanes=0&view=FitH`;
  }


  openInNewPage() {
    window.open(this.url, '_blank')
  }

  zoom(type: 'in' | 'out') {
    type == 'in' ? this.zoomValue += 25 : this.zoomValue -= 25;
  }

  download() {
    const link = document.createElement("a");
    link.href = this.url;
    link.download = this.fileName;
    link.click();
  }

}
